import { getter } from '../proxyGetter'

import { blackFriday } from './blackFriday'
import { holiday } from './holiday'

export const PROMO_THEMES = new Proxy(
  {
    'black-friday-2024': blackFriday,
    'holiday-2024': holiday,
    default: new Proxy({ default: {} }, { get: getter }),
  },
  {
    get: getter,
  },
)
